import { Dialog, Subheader, SubheaderText, useMenuOption } from '@ifca-ui/core'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useDeleteCompanyCommissionTeamDetailMutation } from 'generated/graphql'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { setSnackBar } from 'helpers/snackBarSubjectHelper'

export const DeleteDialog = ({ show, deletedId, onClose, onCompleted }) => {

  const [deleteCompanyCommissionTeamDetail] = useDeleteCompanyCommissionTeamDetailMutation({onCompleted(data, clientOptions) {
    if(data.deleteCompanyCommissionTeamDetail) {
      setSnackBar(SystemMsgs.deleteRecord());
      onCompleted()
    }
  }})

  const onDelete = ()=> {
    if(!deletedId) return onClose()
    deleteCompanyCommissionTeamDetail({variables: {
      id: deletedId
    }})
  }

  return (
    <Dialog
      fullWidth={true}
      open={show}
      onClose={onClose}
      header={
        <Subheader sx={{ padding: '10px 12px' }}>
          <SubheaderText
            primary={
              <Box borderBottom="1px solid #fff">
                <Box display="flex" margin="2px 0px" width="100%">
                  <Typography
                    className="text-xsTitle dialog-title-color"
                    component="span"
                    flex="1 1"
                    variant="inherit"
                  >
                    Company Commission Structure Detail
                  </Typography>
                  <Typography
                    className="text-xsTitle"
                    color='red'
                    component="span"
                    variant="inherit"
                  >
                    Delete
                  </Typography>
                </Box>
              </Box>
            }
          />
        </Subheader>
      }
      body={
        <Box display="block" width="100%" paddingTop='8px' >
          <Typography
            className="text-xsTitle "
            variant="inherit"
          >
            Are you sure want to Delete this ?
          </Typography>
        </Box>}
      footer={{
        buttons: 
          [
            {
              children: 'Cancel',
              color: 'primary',
              onClick: onClose,
            },
            {
              children: 'Delete',
              color: 'primary',
              onClick: () => {
                onDelete()
              },
            },
          ],
      }}
    />
  )
}
